// components/common/AsyncSection.js
import { Flex, Skeleton } from 'antd'
import { Suspense } from 'react'

const AsyncSection = ({
    title,
    skeletonCount = 4,
    children,
    className = 'box_warp just_for_you',
    skeletonHeight = 200,
    paragraphRows = 2
}) => {
    return (
        <div className={className}>
            {title && <div className='title'>{title}</div>}
            <Suspense fallback={
                <Flex className='product_bx'>
                    {[...Array(skeletonCount)].map((_, i) => (
                        <div className='li_product' key={i}>
                            <Skeleton
                                avatar
                                active
                                style={{ width: '100%', height: skeletonHeight }}
                            />
                            <Skeleton
                                active
                                paragraph={{ rows: paragraphRows }}
                            />
                        </div>
                    ))}
                </Flex>
            }>
                {children}
            </Suspense>
        </div>
    )
}

export default AsyncSection